(() => {
  "use strict";

  if (window.__OPTI_CARD_SYNC_FIX_LOADED__) return;
  window.__OPTI_CARD_SYNC_FIX_LOADED__ = true;

  const ROOT_ID = "opti-chatbot";
  const CARDS_KEY = "opti_chat_product_cards_v1";
  const OPTI_ENDPOINT_HOST = "optimus-assistant.m-allali-ams.workers.dev";
  const previousFetch = window.fetch.bind(window);

  function isOptiRequest(input) {
    try {
      const raw = typeof input === "string"
        ? input
        : input instanceof Request
          ? input.url
          : String(input || "");
      const url = new URL(raw, window.location.origin);
      return url.hostname === OPTI_ENDPOINT_HOST;
    } catch (_) {
      return false;
    }
  }

  function getMessages() {
    return document
      .getElementById(ROOT_ID)
      ?.querySelector(".opti-chat__messages") || null;
  }

  function clearRenderedCards() {
    const messages = getMessages();
    if (messages) {
      messages
        .querySelectorAll(":scope > .opti-chat__products")
        .forEach((node) => node.remove());
    }

    try {
      sessionStorage.removeItem(CARDS_KEY);
    } catch (_) {}
  }

  function keepOnlyLatestAndPersist() {
    const messages = getMessages();
    if (!messages) return;

    const blocks = Array.from(
      messages.querySelectorAll(":scope > .opti-chat__products")
    );

    if (!blocks.length) {
      try {
        sessionStorage.removeItem(CARDS_KEY);
      } catch (_) {}
      return;
    }

    const latest = blocks[blocks.length - 1];

    blocks.slice(0, -1).forEach((node) => node.remove());

    try {
      sessionStorage.setItem(
        CARDS_KEY,
        JSON.stringify([latest.outerHTML])
      );
    } catch (_) {}
  }

  function sanitizeLegacyStoredCards() {
    try {
      const saved = JSON.parse(
        sessionStorage.getItem(CARDS_KEY) || "[]"
      );

      if (!Array.isArray(saved) || !saved.length) {
        sessionStorage.removeItem(CARDS_KEY);
        return;
      }

      sessionStorage.setItem(
        CARDS_KEY,
        JSON.stringify(saved.slice(-1))
      );
    } catch (_) {
      try {
        sessionStorage.removeItem(CARDS_KEY);
      } catch (_) {}
    }
  }

  sanitizeLegacyStoredCards();

  window.fetch = async function optiCardSyncFetch(input, init) {
    const response = await previousFetch(input, init);

    if (!isOptiRequest(input)) return response;

    try {
      const data = await response.clone().json();

      if (data?.search?.performed === true) {
        clearRenderedCards();
        window.setTimeout(keepOnlyLatestAndPersist, 0);
        window.setTimeout(keepOnlyLatestAndPersist, 80);
      }
    } catch (_) {}

    return response;
  };

  function installObserver() {
    const messages = getMessages();
    if (!messages) return false;

    if (messages.dataset.optiCardSyncObserved === "true") {
      return true;
    }

    messages.dataset.optiCardSyncObserved = "true";

    const observer = new MutationObserver(() => {
      keepOnlyLatestAndPersist();
    });

    observer.observe(messages, {
      childList: true,
      subtree: false,
    });

    keepOnlyLatestAndPersist();
    return true;
  }

  if (!installObserver()) {
    const rootObserver = new MutationObserver(() => {
      if (!installObserver()) return;
      rootObserver.disconnect();
    });

    rootObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
